export default __webpack_public_path__ + "fc4547d0ccb85d87171f3a3895cdb114.png";